import '../scrollytelling.css'
import './office.css'

import { SceneProvider, useScrollStory } from '../engine'
import OfficeStory from './OfficeStory'

/**
 * Version 3 „Miniatur-Office“: ein isometrisches Büro als Diorama. Eine
 * einzige lange Section mit sticky Bühne, die Kamera fährt beim Scrollen
 * durch die Stationen der Geschichte.
 */
export default function ScrollytellingV3() {
  const story = useScrollStory(1, { mode: 'pin' })

  return (
    <div ref={story.storyRef} className='sty-root off-root'>
      <section
        ref={(el) => (story.chapterRefs.current[0] = el)}
        className='off-section'
        aria-label='Recruiting mit Aivy'
      >
        <div
          ref={(el) => (story.sceneRefs.current[0] = el)}
          className='off-sticky'
        >
          <SceneProvider index={0} subscribe={story.subscribe}>
            <OfficeStory />
          </SceneProvider>
        </div>
      </section>
    </div>
  )
}
